module.exports = __webpack_public_path__ + "static/media/elan2.783f6ff3.jpg";